"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterRelevantFavoriteProperty = void 0;
exports.filterRelevantFavoriteProperty = function (type) {
    if (type === void 0) { type = null; }
    return function (it, i, arr) {
        var EXPIRED_DAY = 30;
        if (!it.available)
            return false;
        if (!it.createdDate)
            return false;
        var expiredMs = EXPIRED_DAY * 24 * 60 * 60 * 1000;
        var createdDate = new Date(it.createdDate);
        var now = new Date();
        if (now.getTime() - createdDate.getTime() > expiredMs)
            return false;
        return true;
    };
};
